<template>
    <div class="icon">
        <svg v-if="name === 'arrow-right'" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.64605 1L14.7859 7.5L7.64605 14" stroke="#28353D" stroke-width="1.5" />
            <path d="M14.574 7.37705H0" stroke="#28353D" stroke-width="1.5" />
        </svg>
        <svg v-else-if="name === 'select-arrow'" width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 2L9.77795 7.31201L18.27 2" stroke="white" stroke-width="3" />
        </svg>
        <svg v-else-if="name === 'facebook'" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.359 24.714V14.822H18.737L19.22 10.962H15.36V8.549C15.36 7.463 15.722 6.619 17.29 6.619H19.34V3.121C18.857 3.121 17.651 3 16.324 3C13.424 3 11.378 4.81 11.378 8.067V10.967H8V14.827H11.378V24.719L15.359 24.714Z" fill="#28353D" />
        </svg>
        <svg v-else-if="name === 'twitter'" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.147 23.381C11.1229 23.3989 13.0825 23.0229 14.9114 22.275C16.7403 21.5271 18.4019 20.4223 19.7991 19.0251C21.1963 17.6279 22.3011 15.9663 23.049 14.1374C23.7969 12.3085 24.1729 10.3489 24.155 8.373V7.659C25.1538 6.89862 26.0227 5.98139 26.728 4.943C25.7701 5.35982 24.7614 5.64832 23.728 5.801C24.7912 5.13346 25.5972 4.12583 26.015 2.942C24.9823 3.51688 23.8766 3.94947 22.728 4.228C22.2442 3.68275 21.6492 3.24754 20.983 2.9517C20.3168 2.65586 19.5949 2.50627 18.866 2.513C17.4701 2.53416 16.1374 3.09808 15.1502 4.08522C14.1631 5.07237 13.5992 6.40513 13.578 7.801C13.5455 8.18781 13.5943 8.57712 13.721 8.944C11.6178 8.84267 9.56051 8.29301 7.68702 7.33186C5.81353 6.37071 4.16709 5.02027 2.858 3.371C2.38752 4.19875 2.14108 5.1349 2.143 6.087C2.16273 6.95005 2.37896 7.79724 2.77525 8.56418C3.17154 9.33111 3.73747 9.99761 4.43 10.513C3.57119 10.4972 2.73223 10.2521 2 9.803C1.99847 11.0273 2.42696 12.2132 3.21068 13.1537C3.9944 14.0942 5.08355 14.7297 6.288 14.949C5.82269 15.0745 5.33995 15.1228 4.859 15.092C4.51933 15.1149 4.17865 15.0661 3.859 14.949C4.20845 16.0078 4.87623 16.9329 5.77112 17.598C6.66602 18.2631 7.74441 18.6357 8.859 18.665C6.98012 20.1327 4.66812 20.9369 2.284 20.952C1.85128 20.9763 1.4175 20.9293 1 20.813C3.36521 22.5306 6.2243 23.4336 9.147 23.386" fill="#28353D" />
        </svg>
        <svg v-else-if="name === 'linkedin'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="#111111">
                <path fill="#111111" d="M23,0H1C0.4,0,0,0.4,0,1v22c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V1C24,0.4,23.6,0,23,0z M7.1,20.5H3.6V9h3.6 V20.5z M5.3,7.4c-1.1,0-2.1-0.9-2.1-2.1c0-1.1,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1C7.4,6.5,6.5,7.4,5.3,7.4z M20.5,20.5h-3.6 v-5.6c0-1.3,0-3-1.8-3c-1.9,0-2.1,1.4-2.1,2.9v5.7H9.4V9h3.4v1.6h0c0.5-0.9,1.6-1.8,3.4-1.8c3.6,0,4.3,2.4,4.3,5.5V20.5z" />
            </g>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'Icon',
    props: {
        name: {
            type: String,
            default: ''
        }
    }
};
</script>

<style lang="scss">
.icon{
    display: inline-block;
    line-height: 0;
}
</style>
